import { formatPosition } from './geometry';

export const getElevation = (position) =>
    new Promise((resolve) => {
        const elevator = new google.maps.ElevationService();
        const request = { locations: [formatPosition(position)] };
        elevator.getElevationForLocations(request, (results, status) =>
            status === 'OK' && results[0] ? resolve(results?.[0]?.elevation) : resolve()
        );
    });
